import React, { Component } from "react";
import { connect } from "react-redux";

import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import SendEmail from "../../Common/SendEmail";
import QuotationPrice from "../../Common/Quotation/Price";
import PriceLines from "../../Common/Quotation/PriceLines";
import Loader from '../../Common/Loader';
import HireButton from "../../Common/Hire";
import Text from '../../Common/Form/Text';
import ErrorMessage from '../../Common/ErrorMessage';

import { apersonal, client } from "../../../operations";
import { 
  setInnerPagesList,
  setStepInnerPage,
  decreaseStepByOne,
  setAPersonalValue,
  setOptionalQuotationValue
} from '../../../actions';
import { numberWithDots } from "../../../helpers";

class Quotation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: true,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { stepInnerPage, setInnerPagesList } = this.props;
    if(!stepInnerPage || stepInnerPage.name !== 'sendEmail')
      setInnerPagesList([
        { name: 'quotation', back: '' },
        { name: 'sendEmail', back: '', backButton: false }
      ]);
  }

  componentDidMount() {
    const { selected } = this.props;
    if(this.slider) this.slider.slickGoTo(selected === 'gold' ? 1 : 0)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if(this.slider) this.slider.slickGoTo(nextProps.selected === 'gold' ? 1 : 0)
  }
 
  priceContent(content) {
    return (
      <div>
        <PriceLines content={content}/>
      </div>
    );
  }

  priceOption(header, content, type) {
    
    const { 
      selected, 
      onAPersonalValueChange 
    } = this.props;

    return (
      <div 
        className={`Quotation-option Quotation-${type} ${selected === type ? 'Quotation-selected' : ''}`}
        onClick={() => onAPersonalValueChange('selected', type)}
      >
        <QuotationPrice
          header={header}
          currency='U$S'
          middle='por año'
          footerFeesOn={true}
          isOptional={type === 'silver'}
          priceContent={() => { return this.priceContent(content) }} 
        />
      </div>
    );
  }

  priceOptions() {

    const {
      insuredGold, insuredSilver,
      onAPersonalValueChange 
    } = this.props;

    const contentSilver = [
      {label:'', value:''},
      {label:'Vamos a garantizar tu tranquilidad por', value:'1 año'},
      {label:'En caso de accidente, recibirás',        value:'U$S ' + numberWithDots(insuredSilver)},
    ];

    const contentGold = [
      {label:'', value:''},
      {label:'Vamos a garantizar tu tranquilidad por', value:'1 año'},
      {label:'En caso de accidente, recibirás',        value:'U$S ' + numberWithDots(insuredGold)},
    ];

    var sliderSettings = {
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerMode: true,
      centerPadding: "40px",
      infinite: false,
      afterChange: current => onAPersonalValueChange('selected', current ? 'gold' : 'silver')
    };

    return (
      <>
        <div className="Quotation-container">
          <div> {this.priceOption('Cobertura Silver', contentSilver, 'silver')} </div>
          <div> {this.priceOption('Cobertura Gold',   contentGold,   'gold'  )} </div>
        </div>
        <div className="Quotation-slider">
          <Slider ref={slider => (this.slider = slider)} {...sliderSettings}>
            <div> {this.priceOption('Cobertura Silver', contentSilver, 'silver')} </div>
            <div> {this.priceOption('Cobertura Gold',   contentGold,   'gold'  )} </div>
          </Slider>
        </div>
      </>
    );
  }

  render() {

    const { 
      stepInnerPage, loading, quoteId,
      sendQuoteByEmail, quoter, name,
      errorMessage, setStepInnerPage, getQuotation
    } = this.props;

    switch (stepInnerPage.name) {
      case 'quotation':
        return (<div>
                  { loading ? 
                      <Loader /> :
                      quoteId > 0 ?
                        <>
                          <Text style={{ paddingTop: '25px'}} className="Text-question"> 
                            {name}, ¡esta es la mejor cotización para vos! 
                            Elegí la que vos prefieras, y dedicate a lo tuyo con la
                            absoluta tranquilidad de que todo va a estar bien.
                          </Text>
                          {this.priceOptions()}
                          <HireButton onThinkClick={() => {
                            setStepInnerPage('sendEmail');
                            sendQuoteByEmail(quoter);
                          }}/>
                        </> : errorMessage ?
                        <ErrorMessage 
                          errorText='Tuvimos un inconveniente con la cotización'
                          tryAgainText= 'Volver a cotizar'
                          tryAgainAction={getQuotation}
                        /> : null
                  }
                </div>);
      case 'sendEmail':
        return <SendEmail />;
    };
    return <div/>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    errorMessage: state.quotation.errorMessage,
    stepInnerPage: state.steps.stepInnerPage,
    name: state.client.name,
    selected: state.apersonal.selected,

    quoteId: state.quotation.quoteId,
    quoter: state.options.quoter,
    insuredGold: state.quotation.insuredAmount,
    insuredSilver: state.quotation.insuredAmountOptional,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInnerPagesList: (page) => {
      dispatch(setInnerPagesList(page));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    },
    onAPersonalValueChange: (type, value) => {
      dispatch(setAPersonalValue(type, value));
      if(type === 'selected') dispatch(setOptionalQuotationValue(value === 'silver'));
    },
    getQuotation: () => {
      dispatch(apersonal.getQuotation());
    },
    sendQuoteByEmail: (quoter) => {
      dispatch(client.sendQuoteByEmail(quoter));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotation);